// Firebase Configuration - Cloud Messaging (FCM) + Firestore
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage'; // ← TAMBAH INI!

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBW9MUNtiSxm5cNiMGVVippa9U9chNjRyg",
  authDomain: "learn-to-trade-54379.firebaseapp.com",
  projectId: "learn-to-trade-54379",
  storageBucket: "learn-to-trade-54379.firebasestorage.app",
  messagingSenderId: "343951062847",
  appId: "1:343951062847:web:fd60edf44b21ad9700c58a",
  measurementId: "G-S8BRKPJXJR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;

try {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.error('Firebase messaging initialization error:', error);
}

// ✅ TAMBAH INI - Initialize Firestore
export const db = getFirestore(app);
// ✅ TAMBAH INI - Initialize Storage
export const storage = getStorage(app);

/**
 * Request notification permission and get FCM token
 */
export const requestNotificationPermission = async () => {
  try {
    console.log('🔔 [Firebase] Requesting notification permission...');

    if (!('Notification' in window)) {
      console.error('❌ [Firebase] Browser does not support notifications');
      return null;
    }

    if (!messaging) {
      console.error('❌ [Firebase] Firebase messaging is not available');
      return null;
    }

    console.log('🔔 [Firebase] Browser supports notifications');
    console.log('🔔 [Firebase] Firebase messaging initialized');

    const permission = await Notification.requestPermission();
    console.log('🔔 [Firebase] Permission result:', permission);

    if (permission === 'granted') {
      console.log('✅ [Firebase] Notification permission granted!');

      const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "YOUR_VAPID_KEY";
      console.log('🔔 [Firebase] VAPID key configured:', vapidKey ? 'Yes' : 'No');

      console.log('🔔 [Firebase] Getting FCM token from Firebase...');
      const token = await getToken(messaging, { vapidKey });

      if (token) {
        console.log('✅ [Firebase] FCM Token obtained:', token.substring(0, 20) + '...');
        console.log('✅ [Firebase] Full token length:', token.length);
        return token;
      } else {
        console.error('❌ [Firebase] No registration token available');
        return null;
      }
    } else if (permission === 'denied') {
      console.warn('⚠️  [Firebase] Notification permission denied by user');
      return null;
    } else {
      console.warn('⚠️  [Firebase] Notification permission dismissed');
      return null;
    }
  } catch (error) {
    console.error('❌ [Firebase] Error getting notification permission:', error);
    console.error('❌ [Firebase] Error details:', error.message);
    return null;
  }
};

/**
 * Listen for foreground messages
 */
export const onMessageListener = (callback) => {
  if (!messaging) {
    console.warn('Firebase messaging is not available');
    return () => { };
  }

  return onMessage(messaging, (payload) => {
    console.log('Message received in foreground:', payload);

    if (payload.notification) {
      const { title, body, icon } = payload.notification;

      new Notification(title, {
        body,
        icon: icon || '/l2t-logo.png',
        badge: '/l2t-logo.png',
        tag: payload.messageId,
        requireInteraction: false,
        data: payload.data
      });
    }

    if (callback && typeof callback === 'function') {
      callback(payload);
    }
  });
};

/**
 * Get current notification permission status
 */
export const getNotificationPermission = () => {
  if (!('Notification' in window)) {
    return 'unsupported';
  }
  return Notification.permission;
};

/**
 * Check if notifications are supported
 */
export const isNotificationSupported = () => {
  return 'Notification' in window && 'serviceWorker' in navigator;
};

// Export FCM messaging and Firestore
export { messaging };
export default app;